module.exports = __webpack_public_path__ + "static/murtha-web.539eea88.jpg";